<template>
    <div id="home">

        <div class="utilities">

            <admin v-if="user.is_superuser" />

            <agenda v-if="user.is_staff" />

        </div>
        
        <booking-list v-if="user.is_staff" />

    </div>
</template>

<script>

    import agenda from '../components/home/Agenda.vue'
    import bookingList from '../components/home/BookingList.vue'
    import admin from '../components/home/Administration.vue'

    export default {
        components: {
            agenda,
            bookingList,
            admin
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            }
        }
    }
</script>

<style lang="scss">

    @import '../styles/vars.scss';

    #home {
        margin: 1rem;
    }

    @media screen and (min-width: $wide) {
        
        #home {
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-start;

            .utilities {
                flex: 0 1 25rem;
            }
            #booking-list {
                flex: 1 0 25rem;
                margin: 0 0 0 2rem;
            } 
        }

    }

</style>